import { Overrides } from '@material-ui/core/styles/overrides'

const paperOverride: Overrides = {
  MuiPaper: {
    rounded: {
      borderRadius: '14px',
    },
  },
}

export default paperOverride
